import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { LayoutService } from '@app/nav/layout/layout.service';
import { Layout, LAYOUTS, lucideFromLayout } from '@app/nav/layout/layouts.model';
import { LucideDynamicIcon } from '@lucide/angular';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-layout-buttons',
  imports: [CommonModule, LucideDynamicIcon, MatButtonModule, MatTooltip, MatFormFieldModule],
  templateUrl: './layout-buttons.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./layout-buttons.scss'],
})
export class LayoutButtons {
  readonly layouts = LAYOUTS;
  readonly layoutService = inject(LayoutService);

  getLucideForLayout(layout: Layout) {
    return lucideFromLayout(layout);
  }

  getLayoutTooltip(layout: Layout) {
    switch (layout) {
      case 'columns-2':
        return 'Affichage en deux colonnes';
      case 'panel-left':
        return 'Affichage du panneau de gauche plus petit';
      case 'panel-right':
        return 'Affichage du panneau de droite plus petit';
    }
  }
}
